import { CarrinhoIngressoService } from './../../../services/carrinho-ingresso/carrinho-ingresso.service';
import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface NavigationHistoryEntry extends EventTarget {
  readonly url?: string;
}
interface NavigationActivation {
  /**
   * The **`entry`** read-only property of the NavigationActivation interface contains a NavigationHistoryEntry object representing the history entry for the inbound ('to') document in the navigation.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/NavigationActivation/entry)
   */
  readonly entry: NavigationHistoryEntry;
  /**
   * The **`from`** read-only property of the NavigationActivation interface contains a NavigationHistoryEntry object representing the history entry for the outgoing ('from') document in the navigation.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/NavigationActivation/from)
   */
  readonly from: NavigationHistoryEntry | null;
  /**
   * The **`navigationType`** read-only property of the NavigationActivation interface contains a string indicating the type of navigation.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/NavigationActivation/navigationType)
   */
  readonly navigationType: NavigationType;
}
interface BrowserNavigation {
  activation: NavigationActivation;
  currentEntry: NavigationHistoryEntry;
}

@Injectable({
  providedIn: 'root',
})
export class CheckoutGuard implements CanActivate {
  private carrinhoIngressoService = inject(CarrinhoIngressoService);
  private router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const hasIngresos =
      this.carrinhoIngressoService.ingressos &&
      this.carrinhoIngressoService.ingressos.length > 0;

    const hasProdutos =
      this.carrinhoIngressoService.produtos &&
      this.carrinhoIngressoService.produtos.length > 0;

    if (!hasIngresos && !hasProdutos) {
      const win: Window & { navigation?: BrowserNavigation } = window as any;
      if (
        'navigation' in win &&
        (win.navigation as BrowserNavigation) &&
        typeof win.navigation === 'object' &&
        (win.navigation as BrowserNavigation) &&
        win.navigation &&
        'activation' in win.navigation &&
        win.navigation.activation != null &&
        typeof win.navigation.activation === 'object'
      ) {
        const activation = win.navigation.activation as NavigationActivation;
        if (activation.from?.url?.includes('/evento/')) {
          return this.router.parseUrl(
            activation.from.url.replace(environment.host, '')
          );
        }
      }
      return this.router.parseUrl('/');
    }
    return true;
  }
}
